/**
 * 日期欄位的存法（同 HR、PM）：存「選的日期」的 UTC 午夜；畫面與表單用本地日期
 * 不用 toISOString().slice(0, 10) 取今天：台灣凌晨 0～8 點會變成前一天
 */
export const ymd = (date: Date) =>
  `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;

/** 今天（本地日期 YYYY-MM-DD） */
export const todayInput = () => ymd(new Date());

/** 資料庫的日期 → 表單 YYYY-MM-DD（UTC 午夜在台灣是當天 08:00，用本地日期即可） */
export const dateInputValue = (value?: string | null) => (value ? ymd(new Date(value)) : '');

/** 表單 YYYY-MM-DD → 送給後端的 ISO（該日 UTC 午夜） */
export const toUtcMidnight = (value: string) => `${value}T00:00:00.000Z`;
